import { useMemo } from 'react';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
export default function useUnfileAssetsName() {
  const objectType = useObjectTypeId();
  const assetName = useMemo(() => {
    const objectTypeNameKey = `frameworkListingLib.objectTypeNames.${objectType}.plural`;
    if (isValidI18nKey(objectTypeNameKey)) {
      return I18n.text('frameworkListingLib.folders.unfiledObjectTypeWithName', {
        objectTypeName: I18n.text(objectTypeNameKey)
      });
    }
    return I18n.text('frameworkListingLib.folders.unfiledObjectType');
  }, [objectType]);
  return assetName;
}